import * as z from "@-/com.npmjs.zod";
import { morphemeDefinitionMorphemeSliceSchema } from "#morpheme-definition-morpheme-slice-schema";
import { morphemeGraphemeMorphemeSliceSchema } from "#morpheme-grapheme-morpheme-slice-schema";
import { cardPinyinListEntrySliceSchema } from "#morpheme-pinyin-list-entry-slice-schema";
import { morphemeTierSchema } from "#morpheme-tier";
import { graphemeStrokeListSchema } from "#grapheme-stroke-slice";

const infoGraphemeComponentMorphemeSliceSchema = z.object({
  grapheme: z.string(),
  pinyinList: z.array(z.string()),
});

export const infoGraphemeMorphemeSliceSchema = z.object({
  biau1Rank: z.int().min(1).nullish(),
  components: z.array(infoGraphemeComponentMorphemeSliceSchema),

  definitionList: z.array(morphemeDefinitionMorphemeSliceSchema),
  grapheme: z.string(),
  graphemeId: z.int(),
  graphemeStrokes: graphemeStrokeListSchema,
  hsk2010Level: z.int().nullish(),
  hsk2021Level: z.int().nullish(),
  hsk2026Level: z.int().nullish(),
  morphemeType: z.literal("grapheme"),
  pinyinList: z.array(cardPinyinListEntrySliceSchema),
  similarGraphemeList: z.array(z.string()),
  subtlexChrRank: z.int().min(1).nullish(),
  tier: morphemeTierSchema,
});

export type ReferenceGraphemeMorphemeSlice = z.infer<typeof infoGraphemeMorphemeSliceSchema>;

export const infoWordMorphemeSliceSchema = z.object({
  biau2Rank: z.int().min(1).nullish(),
  characters: z.array(morphemeGraphemeMorphemeSliceSchema),

  definitionList: z.array(morphemeDefinitionMorphemeSliceSchema),
  hsk2010Level: z.int().nullish(),
  hsk2021Level: z.int().nullish(),

  hsk2026Level: z.int().nullish(),
  morphemeType: z.literal("word"),
  subtlexWfRank: z.int().min(1).nullish(),
  word: z.string(),
  wordId: z.int(),
});

export type ReferenceWordMorphemeSlice = z.infer<typeof infoWordMorphemeSliceSchema>;

/** Minimum data to render the info (dictionary/composition/caligraphy/sentences/progress) side of the back page. */
export const referenceMorphemeSliceSchema = z.union([
  infoGraphemeMorphemeSliceSchema,
  infoWordMorphemeSliceSchema,
]);

export type InfoMorphemeSlice = z.infer<typeof referenceMorphemeSliceSchema>;
